import { Action, createReducer, on } from '@ngrx/store';

import { PermAction } from '../actions';
import { PermState } from '../states';

const initialState: PermState = {
  menus: [],
  current: null,
};

const permReducer = createReducer(
  initialState,
  on(PermAction.SetMenu, (state, { menus }) => ({
    ...state,
    menus,
  })),
  on(PermAction.ResetMenu, (state) => ({
    ...state,
    menus: initialState.menus,
  })),
  on(PermAction.SetCurrent, (state, value) => ({
    ...state,
    current: value.perm,
  })),
  on(PermAction.ResetCurrent, (state) => ({
    ...state,
    current: initialState.current,
  }))
);

export function PermReducer(state: PermState | undefined, action: Action) {
  return permReducer(state, action);
}
